export const CATEGORIES = [
  { id: 'furniture', label: 'Furniture & Fittings' },
  { id: 'equipment', label: 'Equipment' },
  { id: 'computers', label: 'Computers & POS' },
  { id: 'cold_chain', label: 'Cold Chain / Fridges' },
  { id: 'vehicles', label: 'Vehicles' },
  { id: 'buildings', label: 'Buildings' },
  { id: 'leasehold_improvements', label: 'Leasehold Improvements' },
  { id: 'other', label: 'Other' },
];

export const CATEGORY_LABELS = Object.fromEntries(CATEGORIES.map((c) => [c.id, c.label]));

export const METHOD_LABELS = {
  straight_line: 'Straight line',
  declining_balance: 'Declining balance',
};
